import { PButton, PFlexItem, PText } from '@porsche-design-system/components-react'
import React from 'react'

import { PortalContext } from '../../../shared/utils/PortalContext'

import Porsche from '../../../shared/assets/porsche.svg'
import styles from './contentempty.module.css'

const ContentEmpty = () => {
  const { setOpenDrawer } = React.useContext(PortalContext)
  return (
    <PFlexItem className={styles.empty}>
      <img src={Porsche} alt='Porsche' />
      <div className={styles.emptyText}>
        <PText align='center'>Die erste App ist wie der erste Porsche.</PText>
        <PText weight='bold' align='center'>
          Unvergesslich!
        </PText>
      </div>
      <PButton variant='primary' icon='plus' onClick={() => setOpenDrawer(true)}>
        Applikation hinzufügen
      </PButton>
    </PFlexItem>
  )
}

export default ContentEmpty
